import type { Dictionary, Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { Weekday } from '@chancenwerk/enums/enums.js';
import { DateTime } from 'luxon';

@Entity()
export class CourseFilter extends AdornisFilter {
  static override _class = 'CourseFilter';

  constructor(doc: Partial<EntityData<CourseFilter>>) {
    super(doc);
  }

  @Field(() => String)
  courseType: Maybe<string>;

  @Field(() => DateTime)
  date: Maybe<DateTime>;

  @Field(() => String)
  schuKoId: Maybe<string>;

  private static _getWeekdayString(weekday: number | undefined) {
    switch (weekday) {
      case 1:
        return Weekday.MONDAY;
      case 2:
        return Weekday.TUESDAY;
      case 3:
        return Weekday.WEDNESDAY;
      case 4:
        return Weekday.THURSDAY;
      case 5:
        return Weekday.FRIDAY;
      case 6:
        return Weekday.SATURDAY;
      case 7:
        return Weekday.SUNDAY;

      default:
        return Weekday.MONDAY;
    }
  }

  override getMongoFilter() {
    const weekday = this.date?.weekday;
    const obj = this.toObject();
    const selector: Dictionary<any> = {};

    if (obj.courseType) {
      selector._class = this.courseType;
    }
    if (obj.date) {
      selector.weekday = CourseFilter._getWeekdayString(weekday);
    }
    if (obj.schuKoId) {
      selector.schuKoIDs = obj.schuKoId;
    }

    if (obj.searchFields && (obj.search?.length ?? 0) > 0) {
      selector.$or = [];
      for (const field of obj.searchFields) {
        selector.$or.push({ [field]: { $regex: this._safeRegex(obj.search ?? ''), $options: 'i' } });
      }
    }

    return selector;
  }
}
